import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="companies"
export default class extends Controller {
  connect() {
  }

  getSubCategory(e) {
    var item = e.currentTarget
    if(item.value > 0) {
      $.ajax({
        type: "GET",
        url: "/business_categories/get_sub_categories",
        data: {
          id: item.value
        },
        success: function(data) {
          if(data.status == 200) {
            var items = JSON.parse(data.options)

            if(items.length > 0){
              var options = "<option>-- Select Sub Category (optional) --</option>"
              
              Object.keys(items).forEach(function(key){
                options += "<option value='" + items[key]['id'] + "'>" + items[key]['name'] + "</option>";
              })
            } else {
              var options = ""
            }

            document.getElementById('company_business_sub_category_id').innerHTML = options
          } else {
            alert("Sub Categories did not load. Please try again.")
          }
        }
      })
    }
  }
}
